"use client";

import cn from "classnames";
import { FC, useEffect, useRef } from "react";
import Image from "next/image";

import useStateData from "@/hooks/useStateData";

const ProjectModal: FC = () => {
  const { showModal, selectedImage, hideProjectModal } = useStateData();
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        hideProjectModal();
      }
    };

    if (showModal) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showModal, hideProjectModal]);

  const modalClass: string = cn({
    "modal modal-bottom sm:modal-middle": true,
    "modal-open": showModal,
  });

  return (
    <>
      {showModal && (
        <div className={modalClass}>
          <div
            className="fixed z-90 top-6 right-8 text-white text-5xl cursor-pointer hover:text-highlight"
            onClick={hideProjectModal}
          >
            &times;
          </div>
          <div ref={modalRef}>
            <Image
              className="max-w-[1024px] max-h-[720px] object-cover"
              alt={selectedImage?.title || ""}
              height={selectedImage?.height || 0}
              src={selectedImage?.sourceUrl || ""}
              width={selectedImage?.width || 0}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ProjectModal;
